import { createAsyncThunk } from '@reduxjs/toolkit';
import getCredentials from 'utils/getCredentials';
import setFilePermissions from '../services/setFilePermissions';

export const createFilePermissions = createAsyncThunk(
    '/createFilePermissions',
    async (filePermissions, { getState }) => {
        const { accessKeyId, secretAccessKey, sessionToken } =
            await getCredentials();

        const params = {
            accessKeyId,
            secretAccessKey,
            sessionToken,
        };
        const createdFilePermissions = await setFilePermissions(filePermissions, params);
        return { createdFilePermissions };
    }
);